import React from "react";
import WatermarkOverlay from "./WatermarkOverlay";
import { Heart, Download, MessageCircle } from "lucide-react";

const GalleryGrid = ({
  photos = [],
  watermarkText,
  watermarkOpacity,
  watermarkEnabled = true,
  allowSelection = false,
  allowDownloads = false,
  selectedIds = [],
  onToggleSelect,
  onDownload,
  onComment,
  baseUrl = "",
}) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
      {photos.map((photo) => {
        const isSelected = selectedIds.includes(photo.id);
        const photoUrl = photo.url?.startsWith("http") ? photo.url : `${baseUrl}${photo.url}`;

        return (
          <div
            key={photo.id}
            className={`relative group rounded-lg overflow-hidden bg-slate-100 aspect-square cursor-pointer border-2 transition-all ${
              isSelected ? "border-pink-500 ring-2 ring-pink-300" : "border-transparent"
            }`}
            onClick={() => allowSelection && onToggleSelect?.(photo.id)}
          >
            <img
              src={photoUrl}
              alt={photo.filename || "photo"}
              className="w-full h-full object-cover"
              loading="lazy"
            />

            {watermarkEnabled && watermarkText && (
              <WatermarkOverlay text={watermarkText} opacity={watermarkOpacity} />
            )}

            {/* Selection heart */}
            {allowSelection && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onToggleSelect?.(photo.id);
                }}
                className={`absolute top-2 right-2 z-20 w-8 h-8 rounded-full flex items-center justify-center transition-all ${
                  isSelected
                    ? "bg-pink-500 text-white"
                    : "bg-black/40 text-white opacity-0 group-hover:opacity-100"
                }`}
              >
                <Heart className={`w-4 h-4 ${isSelected ? "fill-current" : ""}`} />
              </button>
            )}

            {/* Download button */}
            {allowDownloads && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onDownload?.(photo.id);
                }}
                className="absolute bottom-2 right-2 z-20 w-8 h-8 rounded-full bg-black/40 text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity hover:bg-black/60"
              >
                <Download className="w-4 h-4" />
              </button>
            )}

            {/* Comment button */}
            {onComment && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onComment(photo.id);
                }}
                className="absolute top-2 left-2 z-20 w-8 h-8 rounded-full bg-black/40 text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity hover:bg-black/60"
              >
                <MessageCircle className="w-4 h-4" />
                {photo.comment_count > 0 && (
                  <span className="absolute -top-1 -right-1 bg-indigo-500 text-white text-[10px] w-4 h-4 rounded-full flex items-center justify-center">
                    {photo.comment_count}
                  </span>
                )}
              </button>
            )}

            {/* Filename */}
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/50 to-transparent p-2 opacity-0 group-hover:opacity-100 transition-opacity z-10">
              <p className="text-white text-xs truncate">{photo.filename}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default GalleryGrid;
